import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterCO',
    pure: false
})
export class filterCOPipe implements PipeTransform {
    transform(items: Array<any>, co: string): Array<any> {
        if(items){
            return items.filter(item => item.contaOrcamentaria == co);
        }
    }
}